export const noop = () => {}
export const identity = _ => _

export const bind = (f = noop, ...args) => f.bind(null, ...args)
